//export const BASE_URL = 'http://localhost/joldipabo'; // Localhost
export const BASE_URL = 'https://joldipabo.com'; // Live

export const API_BASE = `${BASE_URL}/api/admin`;
export const MAIN_API_BASE = `${BASE_URL}/api`;

export const API_ENDPOINTS = {
  login: `${API_BASE}/auth/login.php`,
  register: `${API_BASE}/users/register.php`,
};
